import { dateUtils, type Optional } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import type { EventVersionWithCommandType } from '../../hooks/useFilterCommands'
import { useUnappliedCommandReasons } from '../../hooks/useUnappliedCommandReasons'
import { CreatedBy } from '../userDetails/CreatedBy'

type Props = {
  eventVersionWithCommand?: Optional<EventVersionWithCommandType>
}

export const ExtraCommandData = ({ eventVersionWithCommand }: Props) => {
  const translate = useTranslate()

  const { commandVersion } = eventVersionWithCommand ?? {}

  const {
    approvedBy,
    approvedTime,
    createdBy,
    createdTime,
    cancelledBy,
    cancelledTime,
    cancelApprovedTime,
    cancelApprovedBy,
    commandPendingProcessingVersion,
  } = commandVersion ?? {}

  const { cancelPendingUserId } = commandPendingProcessingVersion ?? {}

  const allReasons = useUnappliedCommandReasons(commandPendingProcessingVersion)

  return (
    <>
      {createdBy && (
        <div className="flex items-center gap-1 p-2">
          <span className="whitespace-nowrap font-bold">
            {translate('commandData.createdBy')}:
          </span>
          <span>
            <CreatedBy userId={createdBy} />
          </span>
          <span>-</span>
          <span>{dateUtils.dateWithTimeAsStr(createdTime)}</span>
        </div>
      )}

      {approvedBy && (
        <div className="flex items-center gap-1 p-2">
          <span className="whitespace-nowrap font-bold">
            {translate('commandData.approvedBy')}:
          </span>
          <span>
            <CreatedBy userId={approvedBy} />
          </span>
          <span>-</span>
          <span>{dateUtils.dateWithTimeAsStr(approvedTime)}</span>
        </div>
      )}

      {(cancelledBy || cancelPendingUserId) && (
        <div className="flex items-center gap-1 p-2">
          <span className="whitespace-nowrap font-bold">
            {translate('commandData.cancelledBy')}:
          </span>
          <span>
            <CreatedBy userId={cancelledBy ?? cancelPendingUserId} />
          </span>
          <span>-</span>
          <span>{dateUtils.dateWithTimeAsStr(cancelledTime)}</span>
        </div>
      )}

      {cancelApprovedBy && (
        <div className="flex items-center gap-1 p-2">
          <span className="whitespace-nowrap font-bold">
            {translate('commandData.cancelledApprovedBy')}:
          </span>
          <span>
            <CreatedBy userId={cancelApprovedBy} />
          </span>
          <span>-</span>
          <span>{dateUtils.dateWithTimeAsStr(cancelApprovedTime)}</span>
        </div>
      )}

      {allReasons.length > 0 && (
        <div className="flex items-center gap-1 p-2">
          <span className="whitespace-nowrap font-bold">
            {translate('commandData.reasonForBeingUnapplied')}:
          </span>
          <span>{allReasons}</span>
        </div>
      )}
    </>
  )
}
